import { makeAutoObservable } from 'mobx'
import {
  type IFilterValue,
  type IResponseCustomFilter,
  type IResponseFilter,
} from 'entities/Contacts/api/filterTypes.ts'

export class FilterItemConfig<TValue = IFilterValue> {
  key: string
  type: string
  name: string
  counter: number
  is_values_required: boolean
  minDate: Date | null
  maxDate: Date | null
  category_new: string
  private readonly _values?: TValue[]

  constructor(item: IResponseFilter<TValue> | IResponseCustomFilter) {
    this.key = item.key
    this.type = item.type
    this.name = item.name
    this.minDate = item.minDate ? item.minDate : null
    this.maxDate = item.maxDate ? item.maxDate : null
    this.category_new = item.category_new
    this.is_values_required = Boolean(item.is_values_required)
    this.counter = item.counter ?? 0
    this._values = 'values' in item ? item.values : undefined

    makeAutoObservable(this)
  }

  get values() {
    if (!this._values) return []

    return this._values
  }
}
